// tslint:disable:max-line-length
export const urls = {
    home: 'https://www.lancastergeneralhealth.org',
    onDemand: 'https://www.lancastergeneralhealth.org/ondemand',
    primaryAndSpcialty: 'https://www.lancastergeneralhealth.org/patient-and-visitor-information/find-a-location/lancaster-general-health-physicians-practices',
    primaryCare: ' https://www.lancastergeneralhealth.org/patient-and-visitor-information/find-a-location/lancaster-general-health-physicians-practices',
    // 'https://www.lancastergeneralhealth.org/schedule-an-appointment#tab-1',
    privacyPolicy: 'https://www.lancastergeneralhealth.org/patient-and-visitor-information/patient-information/hipaa-and-privacy/hipaa-and-website-privacy',
    specialtyCare: 'https://www.lancastergeneralhealth.org/patient-and-visitor-information/find-a-location/lancaster-general-health-physicians-practices',
    testing: 'https://www.lancastergeneralhealth.org/schedule-an-appointment#tab-3',
    urgentCare: 'https://www.lghealthurgentcare.org/',
    // '/urgent-care',
};



// WEBPACK FOOTER //
// ./src/utils/urls.ts